module.exports = __webpack_public_path__ + "static/img/ent-detail-78.f2f7c1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-78.jpg
// module id = P1c0
// module chunks = 52